import { ReactElement, useEffect, useRef } from 'react';
import { useGenerateEnergyTrendsGraph } from '../../hooks/useGenerateGraph';
import { EnergyTrendsData } from '../../types';
import { EnergyTrendsFooter } from './Footer';
import { EnergyGraphContainer, GraphContainer } from './styles';

interface EnergyTrendsGraphProps {
  data: EnergyTrendsData | undefined;
  disabled: boolean;
}

export function EnergyTrendsGraph({
  data,
  disabled,
}: Readonly<EnergyTrendsGraphProps>): ReactElement {
  const chartReference = useRef<HTMLDivElement>(null);

  const { renderEnergyTrendsGraph } = useGenerateEnergyTrendsGraph(chartReference, disabled);

  useEffect(() => renderEnergyTrendsGraph(data), [data]);

  return (
    <EnergyGraphContainer>
      <GraphContainer>
        <div id="energy-card" ref={chartReference} style={{ width: '100%', height: '100%' }} />
      </GraphContainer>
      <EnergyTrendsFooter data={data} />
    </EnergyGraphContainer>
  );
}
